import React from 'react';
import ImageHelp from './imageHelp';
import inspectionImage from '../../../../assets/images/help/inspection_help.png';
import '../../utils/style.css';
import { Card } from 'reactstrap';
import { FaHandPointDown } from 'react-icons/fa';

const InspectionHelp = () => {
    return (
        <div className="helpContainer">
            <h2 className="helpTitle">Gestion des Inspections</h2>
            <p className="helpDescription">
                Bienvenue dans la section dédiée à la gestion des inspections de vos véhicules. 
                Ici, vous pouvez planifier, suivre et mettre à jour les inspections pour garantir la sécurité et la conformité de votre flotte.
                Découvrez les fonctionnalités ci-dessous pour une gestion efficace de vos inspections :
            </p>
            <div className="helpFeaturesAndImageContainer">
                <div className="helpTextContainer">
                    <ul className="helpFeaturesList">
                        <li><strong>Suivi des inspections :</strong> Suivez en temps réel l'avancement de chaque inspection et obtenez des informations détaillées sur son statut actuel.</li>
                        <li><strong>Liste des nouvelles inspections :</strong> Visualisez facilement les nouvelles inspections disponibles pour chaque véhicule et gardez un œil sur les actions à entreprendre.</li>
                        <li><strong>Résolution des inspections :</strong> Mettez à jour le statut des inspections une fois qu'elles ont été résolues et validées, pour un suivi précis.</li>
                        <li><strong>Historique des inspections :</strong> Accédez à l'historique complet des inspections passées pour chaque véhicule, et consultez les rapports détaillés de chaque intervention.</li>
                        <li><strong>Analyse des performances :</strong> Obtenez une vision globale des performances des inspections avec des statistiques claires sur le nombre d'inspections défectueuses ou inactes.</li>
                    </ul>
                </div>
                <div className="helpImageContainer">
                    <p className="helpBase">Cliquez sur l'image pour voir de près. <FaHandPointDown className="animated-icon" /></p>
                    <Card className='card-animate'>
                        <ImageHelp fileSource={inspectionImage} width="100%" />
                    </Card>
                </div>
            </div>
            <p className="helpBase">
                Pour plus de détails sur chaque action ou l'application en entier, contactez le support technique de Systalink.
            </p>
        </div>
    );
};

export default InspectionHelp;
